<button sdButton type="primary" fullWidth="true" (click)="onTransitOrder()">оставить заявку</button>
